import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

import Home from './home';
import SuccessStories from './success';
import AboutUs from './about';
import Contact from './contact';
import Test from './test';
import Service from './service';
import Career from './career';
import Culture from './culture';
import Privacy from './privacy';

import { useFonts, Inter_400Regular, Inter_700Bold } from '@expo-google-fonts/inter';
import AppLoading from 'expo-app-loading';

const Stack = createStackNavigator();

// ✅ Deep linking configuration
const linking = {
  prefixes: ['https://integrationx.ai', 'http://localhost:19006'], // include localhost for dev
  config: {
    screens: {
      Home: '',
      AboutUs: 'about',
      SuccessStories: 'success',
      Contact: 'contact',
      Test: 'test',
      Service: 'service',
      Career: 'career',
      Culture: 'culture',
      Privacy: 'privacy', // 👈 this enables https://integrationx.ai/privacy
    },
  },
};

const App = () => {
  const [fontsLoaded] = useFonts({
    Inter_400Regular,
    Inter_700Bold,
  });

  if (!fontsLoaded) {
    return <AppLoading />;
  }

  return (
    <NavigationContainer linking={linking}>
      <Stack.Navigator screenOptions={{ headerShown: false }}>
        <Stack.Screen name="Home" component={Home} />
        <Stack.Screen name="SuccessStories" component={SuccessStories} />
        <Stack.Screen name="AboutUs" component={AboutUs} />
        <Stack.Screen name="Contact" component={Contact} />
        <Stack.Screen name="Test" component={Test} />
        <Stack.Screen name="Service" component={Service} />
        <Stack.Screen name="Career" component={Career} />
        <Stack.Screen name="Culture" component={Culture} />
        <Stack.Screen name="Privacy" component={Privacy} />
      </Stack.Navigator>
    </NavigationContainer>
  );
};

export default App;